import React from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Animation from "../../../ui/components/animation/Animation";
import './HeroSection.css';

const HeroSection = () => {
  const navigate = useNavigate();
  const jwt = Cookies.get("jwt"); 

  const handleGetStarted = () => {
    // Scroll to the contact section (Get In Touch)
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleBookDemo = () => {
    // Scroll to the contact section
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="home-hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="home-hero-title">
            Launch your business website in days, not months.
          </h1>
          <p className="home-hero-subtitle">
            An integrated platform combining analytics and automated workflows—designed to work seamlessly without requiring any technical expertise.
          </p>
          <div className="hero-benefits">
            <ul>
              <li><i className="fas fa-credit-card"></i> Payment integration tailored to your business needs</li>
              <li><i className="fas fa-chart-line"></i> Centralized analytics dashboard</li>
              <li><i className="fas fa-sync-alt"></i> Automated workflows for leads and orders</li>
              <li><i className="fas fa-palette"></i> Custom design and setup based on your industry</li>
            </ul>
          </div>
          <div className="hero-buttons">
            <button className="hero-button primary" onClick={handleBookDemo}>
              Book a Demo
            </button>
            <button className="hero-button secondary" onClick={handleGetStarted}>
              Start Free
            </button>
          </div>
        </div>
        <div className="hero-visual">
          <div className="hero-animation-container">
            <Animation />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

